import { TetherDialog } from '../../../common-module/modules/tether-dialog/tether-dialog';
import { ModalSearchBoxComponent } from '../../../common-module/components/modal-search-box/modal-search-box.component';
import { Observable } from 'rxjs/Rx';
import { Component, OnInit, HostBinding, Input, ComponentRef, ComponentFactoryResolver, Injector, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-movie-search-select',
  templateUrl: './movie-search-select.component.html',
  styleUrls: ['./movie-search-select.component.scss'],
  entryComponents: [ModalSearchBoxComponent]
})
export class MovieSearchSelectComponent implements OnInit {
  @HostBinding('class.c-movie-search-select') true;

  @HostBinding('class.c-movie-search-select--empty')
  get isEmpty(): boolean { return !this.movieList || this.movieList.length == 0 };
  @Input() isRemovable:boolean = true;
  @Input() settings: {
    addLabel: string,
    
    search: {
      title: string,
      placeholder: string,
      presets: { title: string, list: {id: any, title: string, icon?: string, description?:string}[] }[]
      feedback: {
        title: string,
        description: string,
        action?: {action: string, label: string, params?: Object}
      }
    }
  }
  @Input() set movieSearchResult(result) {
    if(this.modalSearchBox) this.modalSearchBox.typeahead.searchData = result;
  }

  @Input() movieList: {id: any, name: string, type?: any, params?: any}[] = [];

  @Input() allowMultiple = true;

  @Input() avatar = false;

  @Output() actionEvent: EventEmitter<{action: string, data?: any}> = new EventEmitter();
  @Output() changeEvent: EventEmitter<{id: any, name: string, type?: any}[]> = new EventEmitter();

  modalSearchBox: ModalSearchBoxComponent;

  movieListDic: {} = {};

  resultSubscription: any;
  feedbackSubscription: any;
  searchSubscription: any;
  dismisSubscription: any;

  constructor(
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    public tether: TetherDialog
  ) { }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    if(this.resultSubscription) this.resultSubscription.unsubscribe();
    if(this.feedbackSubscription) this.feedbackSubscription.unsubscribe();
    if(this.searchSubscription) this.searchSubscription.unsubscribe();
    if(this.dismisSubscription) this.dismisSubscription.unsubscribe();
  }

  selectHandler(result:{id: any, title: string, params?:any}) {
    this.addMovie({id: result.id, name: result.title, type: 0, params: result.params});
    if(this.movieList) return;
  	let hasMovie = this.movieList.find(item => {
  		return (item.id === result.id);
  	});
  	if(!hasMovie){
		  this.actionEvent.emit({action: "select", data: result})
  	}
  }

  changeMovieType(movie: {id: any, name: string, type: any}, event) {
    movie.type = parseInt(event);
    this.actionEvent.emit({action: "patch", data: movie})
    //this.changeEvent.emit(this.movieList);
  }

  addMovie(movie: {id: any, name: string, type: any, params?: any}) {
    if(this.movieListDic[movie.id]){
      this.actionEvent.emit({action: "exist", data: movie})
      return;
    }
    if(!this.movieList) this.movieList = [];
    this.movieListDic[movie.id] = movie;
    this.movieList.push(movie);
    this.actionEvent.emit({action: "add", data: movie})
    this.changeEvent.emit(this.movieList);
  }

  removeMovie(movie: {id: any, name: string, type: any}) {
    let index: number = this.movieList.indexOf(movie);
    if(index >= 0) this.movieList.splice(index, 1);
    delete this.movieListDic[movie.id];
    this.actionEvent.emit({action: "remove", data: movie})
    this.changeEvent.emit(this.movieList);
  }

  searchMovie() {
    let component:ComponentRef<ModalSearchBoxComponent> = this.resolver.resolveComponentFactory(ModalSearchBoxComponent).create(this.injector);
    this.modalSearchBox = component.instance;

    this.modalSearchBox.title = this.settings.search.title;
    this.modalSearchBox.settings = {
      search: this.settings.search
    };

    this.modalSearchBox.presets = Observable.of(this.settings.search.presets);

    this.searchSubscription = this.modalSearchBox.searchEvent.subscribe( result => this.actionEvent.emit({action: "search", data: result}) );
    this.resultSubscription = this.modalSearchBox.resultEvent.subscribe( result => this.selectHandler(result));
    this.dismisSubscription = this.modalSearchBox.dismissEvent.subscribe( result => this.actionEvent.emit({action: "dismiss", data: ''}));

    if(this.settings.search.feedback){
      this.feedbackSubscription = this.modalSearchBox.actionEvent.subscribe( result => this.actionEvent.emit({action: result.action}) );
    }

    this.tether.modal(component, {
      escapeKeyIsActive: true
    }).then(result => {

    }).catch( reason => {
    	this.actionEvent.emit({action: "dismiss", data: ''});
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/backstage-module/components/movie-search-select/movie-search-select.component.ts